import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import { ToolsItem } from './ToolsItem/ToolsItem';
import { useFullScreen } from 'react-browser-hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { updateTopic } from 'redux/actions/topicAction';
import { topicsData } from 'config/topics';
import { showInformation } from 'redux/actions/informationAction';
import { tools, ToolsName } from 'config/tools';

interface IProps {
  orientation: 'horizontal' | 'vertical';
  exclude?: ToolsName[];
}

export const StyledTools = styled.div<{ $orientation: IProps['orientation'] }>`
  display: flex;
  flex-direction: ${({ $orientation }) =>  $orientation === 'horizontal' ? 'row' : 'column'};

  > * + * {
    ${({ theme, $orientation }) =>  {
    switch ($orientation) {
      case 'horizontal':
        return `margin-left: ${theme.spacing[2]}`;
      default:
        return `margin-top: ${theme.spacing[2]}`;
    }
  }}
  }
`;

const Tools: React.FC<IProps> = ({ orientation, exclude = [] }) => {
  const dispatch = useDispatch();
  const fullscreen = useFullScreen();

  const backToHome = useCallback(() => {
    dispatch(updateTopic(topicsData.find((x) => x.id === 0) ?? topicsData[0]));
  }, [dispatch]);

  const openIntroduction = useCallback(() => dispatch(showInformation(true)), [dispatch]);

  const determineAction = useCallback((toolName: ToolsName) => {
    switch (toolName) {
      case 'Fullscreen':
        return fullscreen.toggle;
      case 'Naar begin':
        return backToHome;
      case 'Toon uitleg':
        return openIntroduction;
      default:
        throw new Error(`The toolname '${toolName}' doesn't exist.`);
    }
  }, [backToHome, fullscreen.toggle, openIntroduction]);

  return (
    <StyledTools $orientation={orientation}>
      {tools.map((x) => exclude?.includes(x.title) === false
        ? (
          <ToolsItem
            key={x.id}
            title={x.title}
            onClick={determineAction(x.title)}
            icon={<FontAwesomeIcon size="lg" icon={x.icon} />}
          />
        )
        : null
      )}
    </StyledTools>
  );
};

export { Tools };
